exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-tab-container[data-v-18836761]{width:100%;height:40px;margin-bottom:10px;display:flex}.menu-tab-container .tab[data-v-18836761]{flex:1;height:100%;min-width:800px;display:flex;background-color:#f6f7f9;border-radius:8px}.menu-tab-container .tab .tab-item[data-v-18836761]{width:100px;height:100%;display:flex;justify-content:center;align-items:center;border-radius:8px;font-size:16px;cursor:pointer}.menu-tab-container .tab .current-tab-item[data-v-18836761]{color:#fff;background-color:#31c27c}.menu-tab-container .operation[data-v-18836761]{height:100%}", ""]);

// exports
